import { PROFILE, TESTIMONIALS } from "@/data/portfolio";

const QUOTE_BY_SLUG = {
  "food-industry-ur": "Johannes Callø",
  "sip-and-serve": "Jannik Grann",
  "power-bi-benchmarking": "Piotr M. Klima",
};

const clip = (t, n) => (t.length > n ? `${t.slice(0, n).replace(/\s+\S*$/, "")}…` : t);

export default function OnePager({ cs, pageNo, last }) {
  const t = TESTIMONIALS.find((x) => x.name === QUOTE_BY_SLUG[cs.slug]);
  return (
      <article
        data-testid={pageNo ? `bundle-page-${pageNo}` : "print-sheet"}
        className={`print-sheet ${pageNo && !last ? "sheet-break" : ""} mx-auto bg-white text-[#14352a] w-[210mm] min-h-[297mm] p-[14mm] shadow-xl print:shadow-none grid grid-rows-[auto_1fr_auto] gap-5`}
      >
        <header className="border-b-2 border-[#14352a] pb-3 flex items-end justify-between gap-6">
          <div>
            <div className="font-mono-label text-[9px] text-[#9a7218]">
              {cs.label} · one-page brief
            </div>
            <h1 className="mt-2 font-display text-[26px] leading-[1.1]">{cs.title}</h1>
            <p className="mt-1.5 text-[11.5px] text-[#55625b] leading-snug max-w-[130mm]">{cs.subtitle}</p>
          </div>
          <div className="text-right shrink-0">
            <div className="font-display text-base">{PROFILE.name}</div>
            <div className="font-mono-label text-[8px] text-[#86928a] leading-relaxed">
              Customer Insights &amp; Growth Researcher<br />{PROFILE.location}<br />{PROFILE.email}
            </div>
          </div>
        </header>

        <main className="grid grid-cols-12 gap-5 content-start">
          <div className="col-span-12 grid grid-cols-4 gap-3">
            {cs.metrics.map((m, i) => (
              <div key={i} data-testid={`print-metric-${i}`} className="border-t border-[#14352a] pt-1.5">
                <div className="font-display text-xl leading-none">{m.value}</div>
                <div className="mt-1 font-mono-label text-[7.5px] text-[#86928a] leading-snug">{m.label}</div>
              </div>
            ))}
          </div>

          <Block n="01" title="Context" className="col-span-6">
            <p>{clip(cs.context.replace(/\s+/g, " "), 320)}</p>
          </Block>
          <Block n="02" title="Approach" className="col-span-6">
            <p>{clip(cs.approach.replace(/\s+/g, " "), 320)}</p>
          </Block>

          <Block n="03" title="AI in the workflow, and where I stayed in control" className="col-span-7">
            <p>{clip(cs.aiUsage.replace(/\s+/g, " "), 300)}</p>
          </Block>
          <Block n="04" title="Outcomes" className="col-span-5">
            <ul className="space-y-1">
              {cs.outcomes.filter((o) => !o.startsWith("\"")).slice(0, 3).map((o, i) => (
                <li key={i} className="flex gap-2"><span className="text-[#14352a]">, </span><span>{o}</span></li>
              ))}
            </ul>
          </Block>

          {t && (
            <figure data-testid="print-quote" className="col-span-12 bg-[#f2ece4] p-4 border-l-4 border-[#9a7218]">
              <blockquote className="font-display italic text-[13px] leading-snug">&ldquo;{t.pull}&rdquo;</blockquote>
              <figcaption className="mt-1.5 font-mono-label text-[8px] text-[#86928a]">
                {t.name} · {t.role} · verbatim LinkedIn recommendation
              </figcaption>
            </figure>
          )}

          <Block n="05" title="What I'd do differently" className="col-span-12">
            <p>{clip(cs.reflection.replace(/\s+/g, " "), 260)}</p>
          </Block>
          {cs.csat && (
            <Block n="06" title="One insight → one decision (member survey)" className="col-span-12">
              <div className="grid grid-cols-2 gap-3">
                <p><span className="font-mono-label text-[7.5px] text-[#86928a]">Insight · </span>{cs.csat.loops[0].insight}</p>
                <p className="border-l-2 border-[#9a7218] pl-3"><span className="font-mono-label text-[7.5px] text-[#86928a]">Action · </span>{cs.csat.loops[0].action}</p>
              </div>
            </Block>
          )}
        </main>

        <footer className="border-t border-[#e5e0d8] pt-3 flex items-center justify-between font-mono-label text-[8px] text-[#86928a]">
          <span>Full case study, artefacts and live analytics: {PROFILE.domain}/case-studies/{cs.slug}</span>
          <span>{pageNo ? `${PROFILE.linkedin.replace("https://", "")} · page ${pageNo}` : PROFILE.linkedin.replace("https://", "")}</span>
        </footer>
      </article>
  );
}

export function Block({ n, title, className = "", children }) {
  return (
    <section className={className}>
      <div className="flex items-baseline gap-2 border-b border-[#e5e0d8] pb-1">
        <span className="font-mono-label text-[8px] text-[#9a7218]">{n}</span>
        <h2 className="font-display text-[13px]">{title}</h2>
      </div>
      <div className="mt-1.5 text-[10.5px] leading-[1.45] text-[#14352a]">{children}</div>
    </section>
  );
}
